import CreateColumn from '../../../../Services/agGrid/createColumn';
import dayjs from 'dayjs';

/**
 * PPE_BASIC_04 (보호구 기록) 컬럼 정의
 * 서버 응답: PascalCase (ElCd, ErCd, EquipNm, UserId, Name, EquipDate, EquipYn)
 * 그리드 데이터: camelCase로 저장
 */
export const getColumnDefs1 = (props) => {
  return [
    CreateColumn('name', '사용자명', 'left', 250, false, false, false, 'text', {
      rowGroup: true,
      hide: true,
      minWidth: 200,
    }),
    CreateColumn(
      'equipNm',
      '보호구명',
      'left',
      200,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 150,
      }
    ),
    CreateColumn(
      'equipDate',
      '자가 체크 일자',
      'center',
      170,
      false,
      false,
      false,
      'text',
      {
        minWidth: 150,
        valueFormatter: (params) => {
          if (!params?.value) return '';
          return dayjs(params.value).format('YYYY-MM-DD');
        },
      }
    ),
    CreateColumn(
      'equipYn',
      '체크 유무',
      'center',
      150,
      false,
      false,
      false,
      'text',
      {
        minWidth: 130,
        valueFormatter: (params) => {
          return params.value === 'Y' ? 'Y' : 'N';
        },
      }
    ),
  ];
};

export const getAutoGroupColumnDef1 = () => {
  return {
    headerName: '사용자명',
    minWidth: 250,
  };
};

export default getColumnDefs1;
